import React from 'react';
import { Modal, Descriptions, Switch, Tag, Button } from 'antd';
import moment from 'moment';

import { QRCodeSVG } from 'qrcode.react';
import jsPDF from 'jspdf';
import ReactDOM from 'react-dom';
import { svg2pdf } from 'svg2pdf.js';
import { toast } from 'react-toastify';

const ViewCouponModal = ({ modalVisible, closeModal, selectedCoupon }) => {



    const downloadLocationCodeIDs = async (selectedLocationCodeId, coupon) => {
        try {
            let qrData = ``;
            if(selectedLocationCodeId === null){
                qrData = `${process.env.REACT_APP_BASE_URL}/registration/coupon/${coupon}`;
            }
            else {
                qrData = `${process.env.REACT_APP_BASE_URL}/registration/loc/${selectedLocationCodeId}/coupon/${coupon}`;
            }

            const container = document.createElement('div');
            container.style.position = 'absolute';
            container.style.left = '-9999px'; // Move off-screen
            document.body.appendChild(container);

            ReactDOM.render(
                <QRCodeSVG
                    id="tempQrCodeSVG"
                    value={qrData}
                    size={190}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="H"
                    renderAs='svg'
                />,
                container,
                async () => {
                    try {
                        await new Promise((resolve) => setTimeout(resolve, 500));

                        const svgElement = document.getElementById('tempQrCodeSVG');

                        if (!svgElement) {
                            throw new Error('SVG element not found');
                        }

                        const pdfSize = 250;
                        const margin = 30;
                        const qrSize = pdfSize - 2 * margin;

                        const pdf = new jsPDF({
                            format: [pdfSize, pdfSize]
                        });

                        await svg2pdf(svgElement, pdf, { x: margin, y: margin, width: qrSize, height: qrSize });

                        pdf.save(`qrcode-(${selectedLocationCodeId ? selectedLocationCodeId : 'Public'}-${coupon}).pdf`);
                    } finally {
                        ReactDOM.unmountComponentAtNode(container);
                        document.body.removeChild(container);
                    }
                }
            );
        } catch (error) {
            console.error(error.message);
            toast.error('Something went wrong. Cannot download pdf for location code IDs');
        }
    };




    return (
        <Modal
            title="View Coupon"
            open={modalVisible}
            onCancel={closeModal}
            footer={null}
        >
            {selectedCoupon ? (
                <Descriptions column={1} bordered>
                    <Descriptions.Item label="Coupon Name">{selectedCoupon.couponName}</Descriptions.Item>

                    <Descriptions.Item label="Coupon Code">{selectedCoupon.couponCode}</Descriptions.Item>

                    <Descriptions.Item label="Public Location">
                        <Switch checked={selectedCoupon.isForPublicLocation} disabled />
                    </Descriptions.Item>
                    <Descriptions.Item label="Locations">
                        {selectedCoupon.isForPublicLocation ? (

                            <div key={'public-id'} style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
                                <Tag color="blue">Public</Tag>
                                <Button type="link" onClick={() => downloadLocationCodeIDs(null, selectedCoupon.couponCode)}>
                                    Download
                                </Button>
                            </div>

                        ) : (
                            selectedCoupon.locations?.map(loc => (
                                <div key={loc._id} style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }}>
                                    <Tag>{loc.locationName}</Tag>
                                    <Button type="link" onClick={() => downloadLocationCodeIDs(loc.codeId, selectedCoupon.couponCode)}>
                                        Download
                                    </Button>
                                </div>
                            ))
                        )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Benefit Amount ($)">
                        {selectedCoupon.benefit}
                    </Descriptions.Item>
                    <Descriptions.Item label="Coupon Type">
                        {selectedCoupon.type === 'account-creation' ? 'Account Creation' : 'Promotion'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Number of Usage">
                        {selectedCoupon.numberOfUsage || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Expiry Date">
                        {selectedCoupon.expiry ? moment(selectedCoupon.expiry).format('YYYY-MM-DD') : 'No Expiry'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Enabled">
                        <Switch checked={selectedCoupon.enabled} disabled />
                    </Descriptions.Item>
                </Descriptions>
            ) : (
                <p>No coupon details available.</p>
            )}
        </Modal>
    );
};

export default ViewCouponModal;